import { useTranslation } from "react-i18next";

const OrderTotals = ({ itemsCount, subtotal, totalCost = "€0.00" }) => {
    const { t } = useTranslation();
    const subtotalValue = subtotal ?? totalCost;

    return (
        <div className="mt-8">
            <p className="text-sm font-semibold text-slate-900">{t("GIFT_ORDER_TOTALS_TITLE")}</p>
            <div className="mt-4 space-y-3 text-sm text-slate-600">
                <div className="flex items-center justify-between border-b border-slate-200 pb-3">
                    <span>{t("GIFT_ORDER_TOTALS_ITEMS")}</span>
                    <span>{itemsCount} {t("COMMON_PRODUCTS")}</span>
                </div>
                <div className="flex items-center justify-between border-b border-slate-200 pb-3">
                    <span>{t("COMMON_SUBTOTAL")}</span>
                    <span>{subtotalValue}</span>
                </div>
                <div className="flex items-center justify-between border-b border-slate-200 pb-3">
                    <span>{t("COMMON_SHIPPING")}</span>
                    <span className="font-medium text-primary">{t("COMMON_FREE")}</span>
                </div>
                <div className="flex items-center justify-between border-b border-slate-200 pb-3">
                    <span className="text-green-600">{t("COMMON_DISCOUNT")}</span>
                    <span className="font-medium text-green-600">100%</span>
                </div>
                <div className="flex items-center justify-between font-semibold text-slate-900">
                    <span>{t("GIFT_ORDER_TOTALS_TOTAL_COST")}</span>
                    <span>{totalCost}</span>
                </div>
            </div>
        </div>
    );
};

export default OrderTotals;
